import React from 'react'
import { Paper, Typography, Container, LinearProgress } from '@mui/material';

const UploadingLoading = () => {
  return (
    <Container  maxWidth='xl' style={{ marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper elevation={3} style={{padding: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center'}}>
        <Typography variant='h4' style={{ fontWeight: 700 }}>Subiendo imagen ...</Typography>
        <Typography variant='body1' className='my-3' color='primary.light'><i className='fad fa-images fa-5x'></i></Typography>
        <LinearProgress />
      </Paper>
    </Container>
  )
}

export default UploadingLoading
